export default __webpack_public_path__ + "img/fsaYNaLB.40ba99a0.svg";